export const mediaQuery = {
  tablet: `@media (min-width: 576px)`,
  desktop: `@media (min-width: 768px)`,
  wide: `@media (min-width: 992px)`,
}
